export default function HowItWorks() {
  const steps = [
    ["Postcode check","We confirm your address is inside our serviceable area before you spend any time configuring."],
    ["Route selection","Already have planning? We unlock larger sizes and pitched roofs. No planning? We run an indicative Permitted Development screening."],
    ["Site & logistics","A handful of yes/no questions: ULEZ, rear access width, demolition, steel beam, build-over agreement. Each adjusts the price honestly."],
    ["Live 3D configurator","Drag your width and depth. Pick walls, roof, doors. The model and the total move with you."],
    ["Pick your start","Calendar of available weeks. Fixed price, fixed start date — once your survey is signed off, your slot is yours."],
    ["Book & survey","Pay a £499 booking fee to reserve your date and lock in the price. It comes off your 10% deposit; the balance is due once your on-site survey is completed and signed off."],
    ["Survey & pack","On-site survey within two weeks. Architectural pack issued. Building Control booked on your behalf."],
    ["From footings to finish","One crew, fourteen weekly payments, twelve-month workmanship warranty."],
  ];
  return (
    <main data-testid="how-it-works-page" className="px-6 md:px-12 lg:px-16 pt-16 pb-24">
      <div className="label-eyebrow mb-6">How It Works</div>
      <h1 className="font-black tracking-tighter leading-[0.95] text-5xl md:text-7xl max-w-4xl">Eight steps. One team. No surprises.</h1>
      <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10">
        {steps.map(([t, d], i) => (
          <div key={i} className="flex gap-6">
            <div className="text-3xl font-black text-[#C79A3B] w-12">{String(i + 1).padStart(2, "0")}</div>
            <div>
              <div className="font-bold text-xl">{t}</div>
              <div className="mt-2 text-[#6B7280] leading-relaxed">{d}</div>
            </div>
          </div>
        ))}
      </div>
    </main>
  );
}
